import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getBlog = () => api.get("/blog").then((r) => r.data);
export const getPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const getTestimonials = () => api.get("/testimonials").then((r) => r.data);
export const getImpact = () => api.get("/impact").then((r) => r.data);

export const submitDonation = (data) => api.post("/donate", data).then((r) => r.data);
export const createDonationCheckout = (data) => api.post("/payments/donate/checkout", data).then((r) => r.data);
export const getPaymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`).then((r) => r.data);
export const getPaypalConfig = () => api.get("/payments/paypal/config").then((r) => r.data);
export const createPaypalOrder = (data) => api.post("/payments/paypal/create-order", data).then((r) => r.data);
export const capturePaypalOrder = (orderId) => api.post(`/payments/paypal/capture/${orderId}`).then((r) => r.data);
export const submitVolunteer = (data) => api.post("/volunteer", data).then((r) => r.data);
export const submitGoods = (data) => api.post("/donate-goods", data).then((r) => r.data);
export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const submitPrayer = (data) => api.post("/prayer-enroll", data).then((r) => r.data);
